import CustomSelectBox from "../../components/ReactSelect/ReactSelect";
import styles from "./TopLabelReactSelect.module.css";
import { Controller } from "react-hook-form";

const customStyleProps = {
  width: "100%",
  height: "40px",
  borderRadius: "9999px",
  border: "0",
  padding: "2px 0 2px 0",
  boxShadow: "none",
  arrowColor: "#bfc5ce",
  showPipe: true,
};

const TopLabelCustomSelectBox = ({
  options,
  label,
  name,
  // register,
  errors,
  // validation = {},
  placeholder = "Select",
  mandate = false,
  errorMessage,
  control,
  validation,
  disabled = false,
}) => (
  <div className={styles.wrapper}>
    <fieldset
      className={`${styles.fieldset}  ${disabled ? styles.disabled : ""} ${
        errors?.[name] ? styles.error : ""
      }`}
    >
      <legend className={styles.legend}>
        {label} {mandate && <span className={styles.mandate}> *</span>}
      </legend>

      <Controller
        name={name}
        control={control}
        rules={validation}
        defaultValue={null}
        render={({ field }) => {
          const rawValue =
            field.value && typeof field.value === "object"
              ? field.value.value
              : field.value;

          const selectedOption =
            (options &&
              options.find((opt) => String(opt.value) === String(rawValue))) ||
            null;
          return (
            <CustomSelectBox
              options={options}
              customStyleProps={customStyleProps}
              placeholder={placeholder}
              value={selectedOption}
              isDisabled={disabled}
              onChange={(selected) => field.onChange(selected?.value)}
              onBlur={field.onBlur}
              inputRef={field.ref}
              errorMessage={errorMessage}
            />
          );
        }}
      />
    </fieldset>

    {errorMessage && <p className={styles.errorText}>{errorMessage}</p>}
  </div>
);

export default TopLabelCustomSelectBox;
